export class PriorityFilter
{
    Overtime: boolean;
    High: boolean;
    HotParts: boolean;
    Normal: boolean;
    Warranty: boolean;
    PM: boolean;
    Locked: boolean;
    SpecialEquipment: boolean;
}
